var styles = {"fontElementMap":"cMx2p","orderedlist":"cPHJh","bulletedlist":"j0Ou8","listItem":"glMBs"};

export { styles as s };
//# sourceMappingURL=lists-be20743a.js.map
